<template>
  <b-modal
    :ok-title-html="modalsubmit==true?loaderIcon+'Update':'Update'"
    :ok-disabled="modalsubmit"
    @ok="handleSubmit()"
    id="reportingtagmodal"
    ref="reportingtagmodal"
    size="md"
    ok-title="update"
    :title="'Associate Reporting Tags'"
    :no-close-on-backdrop="true"
    cancel-variant="light"
    body-class="bg-white"
  >
    <b-form>
      <b-row>
        <b-col v-if="reporting_tags.length==0">
          <p class="text-muted">You've not created any Reporting Tags.</p>
        </b-col>
        <b-col
          v-else-if="reporting_tags.filter(tag=>(tag.status==='0'&&singleitemrow[tag.tag_column_name]!='')||tag.status==='1').length==0"
        >
          <p
            class="text-muted"
          >There are no active reporting tags or you've not created a reporting tag yet.You can create/edit reporting tags under settings</p>
        </b-col>
        <template v-else>
          <b-col cols="6" v-for="(tag,index) in reporting_tags" :key="index">
            <b-form-group
              :label-for="'tag field' +index"
              :label="tag.tag_name"
              v-if="tag.tag_options.filter(x=>(x.is_active==false&&data[tag.tag_column_name]==x.value)||x.is_active).length>0"
            >
              <v-select
                :clearable="data[tag.tag_column_name]!=''&&data[tag.tag_column_name]!=null"
                @input="$event=null?data[tag.tag_column_name]='':''"
                v-model="data[tag.tag_column_name]"
                index="value"
                label="label"
                :options="tag.tag_options.filter(x=>(x.is_active==false&&singleitemrow[tag.tag_column_name]==x.value)||x.is_active)"
              ></v-select>
            </b-form-group>
          </b-col>
        </template>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import vSelect from "vue-select"; // vue seatch select component
import { mapGetters } from "vuex"; // get data set in the state in vuex

export default {
  props: ["singleitemrow", "data"],
  components: {
    vSelect
  },
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      message: "",
      modalsubmit: false
    };
  },
  methods: {
    handleSubmit() {
      this.modalsubmit = true;
      //update reporting tag field values to item
      for (var i = 0; i < this.reporting_tags.length; i++) {
        this.$set(
          this.singleitemrow,
          this.reporting_tags[i].tag_column_name,
          this.data[this.reporting_tags[i].tag_column_name]
        );
      }
      this.$refs.reportingtagmodal.hide();
      this.modalsubmit = false;
    }
  },
  computed: {
    ...mapGetters(["reporting_tags"])
  }
};
</script>
